import * as React from "react"
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"


export default function countryColumn() {
	return {
		name: 'country',
		label: 'Country',
		options: {
			filter: false,
			customBodyRowRenderLite: value => translateCountryName(value) === 'Unknown'
				? value
				: <LabelCountry country={value} label={translateCountryName(value)}
			/>
		}
	}
}